(() => {
  const pad = (value) => String(Math.max(0, value)).padStart(2, '0');

  const initCountdown = (root) => {
    const target = Date.parse(root.dataset.saleEnd || '');
    if (!Number.isFinite(target)) return;

    const days = root.querySelector('[data-countdown-days]');
    const hours = root.querySelector('[data-countdown-hours]');
    const minutes = root.querySelector('[data-countdown-minutes]');
    const seconds = root.querySelector('[data-countdown-seconds]');
    const label = root.querySelector('[data-countdown-label]');
    const grid = root.querySelector('[data-countdown-grid]');
    const ended = root.querySelector('[data-ended-message]');
    let intervalId;

    const update = () => {
      const remaining = target - Date.now();
      if (remaining <= 0) {
        root.classList.add('ya-bss--ended');
        if (label) label.textContent = 'The Big Summer Sale has ended';
        if (grid) grid.hidden = true;
        if (ended) ended.hidden = false;
        if (intervalId) window.clearInterval(intervalId);
        return;
      }

      const totalSeconds = Math.floor(remaining / 1000);
      if (days) days.textContent = pad(Math.floor(totalSeconds / 86400));
      if (hours) hours.textContent = pad(Math.floor((totalSeconds % 86400) / 3600));
      if (minutes) minutes.textContent = pad(Math.floor((totalSeconds % 3600) / 60));
      if (seconds) seconds.textContent = pad(totalSeconds % 60);
    };

    update();
    intervalId = window.setInterval(update, 1000);
  };

  const buildCartUrl = (variantId, sellingPlanId = '') => {
    const base = window.routes?.cart_add_url || '/cart/add';
    const params = new URLSearchParams({ id: String(variantId), quantity: '1' });
    if (sellingPlanId) params.set('selling_plan', String(sellingPlanId));
    return `${base}?${params.toString()}`;
  };

  const setCartLinkState = (link, variantId, sellingPlanId, disabled) => {
    if (!link) return;
    if (disabled) {
      link.removeAttribute('href');
      link.setAttribute('aria-disabled', 'true');
      link.setAttribute('tabindex', '-1');
      return;
    }
    link.href = buildCartUrl(variantId, sellingPlanId);
    link.removeAttribute('aria-disabled');
    link.removeAttribute('tabindex');
  };

  const initVariantSelectors = (root) => {
    root.querySelectorAll('[data-sale-variant-select]').forEach((select) => {
      select.addEventListener('change', () => {
        const card = select.closest('[data-sale-card]');
        const option = select.options[select.selectedIndex];
        if (!card || !option) return;

        const regular = card.querySelector('[data-regular-price]');
        const promo = card.querySelector('[data-promo-price]');
        if (regular && option.dataset.regularPrice) regular.textContent = option.dataset.regularPrice;
        if (promo && option.dataset.promoPrice) promo.textContent = option.dataset.promoPrice;

        const variantId = option.value;
        const unavailable = Boolean(option.disabled);
        const oneTimeLink = card.querySelector('[data-sale-cart-link][data-cart-mode="one-time"]');
        setCartLinkState(oneTimeLink, variantId, '', unavailable);

        const subscriptionLink = card.querySelector('[data-sale-cart-link][data-cart-mode="subscription"]');
        if (subscriptionLink) {
          const planId = option.dataset.sellingPlanId || '';
          subscriptionLink.dataset.sellingPlanId = planId;
          setCartLinkState(subscriptionLink, variantId, planId, unavailable || !planId);
        }
      });
    });
  };

  const init = () => {
    document.querySelectorAll('[data-big-summer-sale]').forEach((root) => {
      initCountdown(root);
      initVariantSelectors(root);
    });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
